import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { ttProtectionFilterUrls } from "../../../../../URL/ApplicationUrls";
import {
  emptyTtProtectionFilterSelection,
  SelectedTtProtectionFilters,
} from "../SelectedTtProtectionFilters";
import { ttProtectionSelectedFiltersWithIdQueryKey } from "../ttProtectionQueryKey";

export const useFetchSelectedFiltersForTtProtection = (ttProtectionId: number) => {
  return useQuery<SelectedTtProtectionFilters, Error>({
    queryKey: [ttProtectionSelectedFiltersWithIdQueryKey(ttProtectionId)],
    queryFn: () => fetchSelectedFilters(ttProtectionId),
    onError: () => {
      toast.error(
        `An error occurred when retrieving selected filters for TT Protection with the P-Nr. ${ttProtectionId}`
      );
    },
  });
};

const fetchSelectedFilters = async (ttProtectionId: number | string | undefined) => {
  if (!ttProtectionId) return Promise.resolve(emptyTtProtectionFilterSelection);

  const { data: selectedFilters } = await axios.get<SelectedTtProtectionFilters>(
    ttProtectionFilterUrls.selectedFilterForTtProtection(ttProtectionId)
  );

  return selectedFilters;
};
